import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "register-domain"
    }}>{`Register domain`}</h2>
    <ol>
      <li parentName="ol">{`We have hosting (digitalocean droplet) for our cezerin web site.`}</li>
    </ol>
    <p>{`Now we need a domain name, to open our store like this`}</p>
    <pre><code parentName="pre" {...{}}>{`https://cezerin.net
`}</code></pre>
    <p>{`not by ip address like:`}</p>
    <pre><code parentName="pre" {...{}}>{`https://123.456.789.0
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`You need to register any domain name at any domain registrator.`}</li>
    </ol>
    <p>{`For example, we have cezerin.net domain and we need to make available cezerin
online store on `}<a parentName="p" {...{
        "href": "https://cezerin.net"
      }}>{`https://cezerin.net`}</a></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Ok, we have domain name and we have domain name control panel.`}</li>
    </ol>
    <p>{`Let's go to attach domain and hosting.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      